// eslint-disable-next-line @typescript-eslint/no-unused-vars
const useMaximumScreenBrightness = (shouldApply: boolean = true) => {};

export default useMaximumScreenBrightness;
